import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import logo from '@/imgs/logo.png'
import { openExternalUrl } from '@/lib/native'

type Props = {
  storeUrl?: string
}

export function ForceUpdateScreen({ storeUrl }: Props) {
  const { t } = useTranslation()

  return (
    <div dir='rtl' className='bg-background-app fixed inset-0 z-50 flex min-h-dvh w-full items-center justify-center p-6'>
      <div className='flex max-w-sm flex-col items-center gap-6 text-center'>
        <img src={logo} alt='ShipTanbul' className='h-auto w-40' />
        <div className='space-y-2'>
          <h1 className='text-text-primary text-2xl font-bold'>{t('native.forceUpdateTitle')}</h1>
          <p className='text-text-secondary text-base'>{t('native.forceUpdateBody')}</p>
        </div>
        {storeUrl ? (
          <Button type='button' size='lg' onClick={() => void openExternalUrl(storeUrl)}>
            {t('native.updateNow')}
          </Button>
        ) : null}
      </div>
    </div>
  )
}
